/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

import { registerLocaleData } from '@angular/common';
import localefr from '@angular/common/locales/fr';

registerLocaleData(localefr);

import './ic2/entities/entities';
import './ic2/services/services';

if (environment.production) {
  // Production mode is handled by the build configuration
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  let message = '';

  const loadingElement = document.querySelector('#LoadingElement') as HTMLElement;
  const errorMsgElement = document.querySelector('#errorMsgElement') as HTMLElement;
  const refreshButton = document.querySelector('#refreshButton') as HTMLButtonElement;

  loadingElement.style.display = 'none';

  if (err.message == 'Time') message = 'Loading in progress, please hang tight';
  else if (err.message == 'Down') message = 'An error occurred, please try again later';

  errorMsgElement.textContent = message;
  refreshButton.style.display = 'block';
});
